import { TinyColor } from '@ctrl/tinycolor';

var getContentSwitcherHoverBackground = function getContentSwitcherHoverBackground(propColor, propBackground) {
  var color = new TinyColor(propColor);
  var background = new TinyColor(propBackground);
  var hoverBackground = background.mix(color, 5);
  return hoverBackground.toHexString();
};

export { getContentSwitcherHoverBackground };
